import React, { FC, useCallback, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import { EvSpinner } from '@evinced-private/ui-common';

import { FullPageError } from '../../components/full-page-error/FullPageError';
import { handleSuccessfulAuthentication } from '../../helpers/AuthenticationHelper';
import { useUniversalLogin } from '../../hooks/useUniversalLogin';
import { useUserTenant } from '../../providers/userTenantProvider/UserTenantProvider';
import { logger } from '../../services/Logger';
import { getRedirectToPath } from '../../services/LoginRedirectionService';

import { AUTH_TOKEN_LABELS } from './AuthToken.labels';

const AuthToken: FC = () => {
	const { getAccessToken } = useUniversalLogin();
	const history = useHistory();
	const { updateUserTenant } = useUserTenant();
	const [hasAuthenticationError, setHasAuthenticationError] = useState(false);

	const handleAuthentication = useCallback(async () => {
		try {
			setHasAuthenticationError(false);
			const accessToken = await getAccessToken();
			await handleSuccessfulAuthentication(
				{ accessToken, idToken: accessToken, appState: null },
				history
			);
			await updateUserTenant();
			const { path } = getRedirectToPath();
			history.push(path);
		} catch (e) {
			logger.error('Error in handling authentication', e);
			setHasAuthenticationError(true);
		}
	}, [getAccessToken, history, updateUserTenant]);

	useEffect(() => {
		handleAuthentication();
	}, [handleAuthentication]);

	if (hasAuthenticationError) {
		return <FullPageError title={AUTH_TOKEN_LABELS.authenticationErrorTitle} />;
	}

	return <EvSpinner />;
};

export { AuthToken };
